import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FullScreenModeProps {
    isEnabled: boolean;
}
const initialState: FullScreenModeProps = {
    isEnabled: false,
};
const FullScreenModeSlice = createSlice({
    name: 'FullScreenModeSlice',
    initialState,
    reducers: {
        setFullScreenModeEnabled: (state, action: PayloadAction<boolean>) => {
            state.isEnabled = action.payload;
        },
    },
});

export const { setFullScreenModeEnabled } = FullScreenModeSlice.actions;
export default FullScreenModeSlice.reducer;
